"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_roaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bff151ad-e388-494c-88d8-8950d093c77c",
    x1: 578.75,
    y1: -2858,
    x2: 611.98,
    y2: -2858,
    gradientTransform: "matrix(0.71, 0.71, -1.27, 1.27, -3928.07, 3283.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "roaming-hi"), /*#__PURE__*/React.createElement("g", {
    id: "4e98011c-69a8-4cf5-8763-44097fb28a54",
    "data-name": "roaming-hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.25,76.75a9,9,0,0,0-6.9-.4L16,79,29.32,95.43,50.24,88Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43,52.53l-35,12.42L85.53,75.51,50.24,88,29.32,95.43l.35.43c10.05,12,24.94,16.61,39.76,11.44l89-31.72a27.48,27.48,0,0,0,17.56-19A27.47,27.47,0,0,0,150.43,52.53Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,73.22l-89,31.72c-14.82,5.17-29.71.61-39.76-11.44L17.43,78.41,16,79,29.68,95.86c10.05,12,24.94,16.61,39.76,11.44l89-31.72a27.48,27.48,0,0,0,17.56-19l-.63-.44A27.44,27.44,0,0,1,158.46,73.22Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.69 94.81 91.79 81.9 125 70.13 137.78 82.91 104.69 94.81",
    opacity: 0.2,
    fill: "url(#bff151ad-e388-494c-88d8-8950d093c77c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.91,82,56.51,46l9.86-3.44a10.45,10.45,0,0,1,8.14.54l50.8,27.15",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.05 69.06 91.91 79.99 57.97 45.51 56.51 46.02 91.91 81.99 125.31 70.27 123.05 69.06",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    id: "1d14d1ef-8ff4-4319-a110-1e5eb8a6a7f2",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22974048-cb27-485b-8953-0112deddfe5b",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "79dce13b-4698-42ff-b20e-2ebedfac01ce",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18ac9eeb-5b9b-4aab-932b-ad5f60d6d093",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "942275f9-e65b-4480-98fb-713c8ce2cdc9",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "59fb0e39-94dc-4078-a2ff-83c101f4bced",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28b84d53-5df7-487d-9ce0-eeb4173022b2",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d193fd9c-9247-40e5-b0ab-75267eb174f8",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c2c6b56e-f379-404f-abbd-ec08feb763fb",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "68cbf9c5-b71c-4051-bfc4-b11c4ac09d53",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "973cb4f3-9401-490d-9534-c316efe67b67",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b932255f-272a-448d-a96d-86d1a22f2514",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4e5b3567-542d-4a33-9ae2-f1969c2e10c7",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ddcb4a00-5c6f-4d46-9ff1-39227c36bef6",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "76e7211a-a0b8-4d95-8e54-63126986cc9e",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a56b6616-003a-4d23-a58c-32d4a0f67f53",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7f4c918f-1ef4-4fc8-9656-b82791d2fc1b",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d6700750-519e-40ef-a360-9a2c4848953b",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fafb0ff3-8f06-4586-aa59-8ea06337cd51",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0589dfa1-f1ae-4be8-99d8-9926381bfdc6",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "65d316ed-4e89-4234-80fa-054eeb5e622b",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166,152H26a2,2,0,1,1,0-4H166a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })))))))))))))))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "16 79.01 16 79.01 16.33 78.88 16 79.01",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.43 78.42 16.33 78.88 17.43 78.42 17.43 78.42",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.88,94.88c-.41-.45-.81-.9-1.2-1.37L17.43,78.41l-1.1.46L16,79,29.32,95.43Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.88,94.88c-.41-.45-.81-.9-1.2-1.37L17.43,78.41l-1.1.46L16,79,29.32,95.43Z",
    transform: "translate(0 0)",
    opacity: 0.12
  })));
}

var _default = ic_roaming;
exports.default = _default;